<template>
  <div id="app">
    <Navigation/>
  </div>
</template>

<script>
import Navigation from './components/navigation/Navigation'

export default {
  components: {
    Navigation
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>
